(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menade-hanging-collection"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('menade-rack-v4')) {
 customElements.define('menade-rack-v4', class extends HTMLElement {
  connectedCallback() {
   if(this.bound)return;
   this.bound=true;
   this.abort=new AbortController();
   const signal=this.abort.signal;
   const track=this.querySelector('[data-mh-track]');
   const items=Array.from(this.querySelectorAll('[data-mh-item]'));
   if(!track||items.length===0)return;
   const prev=this.querySelector('[data-mh-prev]');
   const next=this.querySelector('[data-mh-next]');
   const progress=this.querySelector('[data-mh-progress]');
   const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
   
   const state=new Map(items.map(item=>[item,{base:item.dataset.startBack==='true'}]));
   const display=(item,back)=>{
    item.classList.toggle('is-back',back);
    item.querySelector('[data-mh-turn]').setAttribute('aria-pressed',String(back));
    item.querySelector('[data-mh-front]').setAttribute('aria-hidden',String(back));
    item.querySelector('[data-mh-back]').setAttribute('aria-hidden',String(!back));
    item.querySelector('[data-mh-side]').textContent=back?this.dataset.backLabel:this.dataset.frontLabel;
   };
   const zoom=(item,on)=>{
    item.classList.toggle('is-active',on);
    const lift=item.querySelector('.mh2-lift');
    if(on)lift.style.setProperty('transform','scale(1.25)','important');
    else lift.style.removeProperty('transform');
   };
   this.addEventListener('pointerdown',event=>{
    this.classList.toggle('mh2-touch',event.pointerType==='touch');
   },{signal});
   this.addEventListener('pointermove',event=>{
    if(event.pointerType==='mouse')this.classList.remove('mh2-touch');
   },{signal,passive:true});
   items.forEach(item=>{
    const button=item.querySelector('[data-mh-turn]');
    button.disabled=false;
    display(item,state.get(item).base);
    button.addEventListener('pointerenter',event=>{
     if(event.pointerType!=='mouse'||this.dragging)return;
     zoom(item,true);
     display(item,!state.get(item).base);
    },{signal});
    button.addEventListener('pointerleave',event=>{
     if(event.pointerType!=='mouse')return;
     zoom(item,false);
     display(item,state.get(item).base);
    },{signal});
    button.addEventListener('click',()=>{
     if(performance.now()<(this.suppressClickUntil||0))return;
     const back=!item.classList.contains('is-back');
     state.get(item).base=back;
     display(item,back);
    },{signal});
   });
   const step=()=>items.length>1?items[1].offsetLeft-items[0].offsetLeft:track.clientWidth;
   const go=(amount)=>track.scrollBy({left:amount*step(),behavior:reduced()?'instant':'smooth'});
   const update=()=>{
    const max=Math.max(0,track.scrollWidth-track.clientWidth);
    prev.disabled=track.scrollLeft<=2;
    next.disabled=track.scrollLeft>=max-2;
    const first=Math.max(0,Math.min(items.length-1,Math.round(track.scrollLeft/Math.max(1,step()))));
    const visible=Math.max(1,Math.floor((track.clientWidth+Math.max(0,step()-items[0].offsetWidth)+1)/Math.max(1,step())));
    progress.textContent=(first+1)+'–'+Math.min(items.length,first+visible)+' / '+items.length;
   };
   this.querySelector('[data-mh-controls]').hidden=false;
   prev.addEventListener('click',()=>go(-1),{signal});
   next.addEventListener('click',()=>go(1),{signal});
   track.addEventListener('scroll',update,{signal,passive:true});
   track.addEventListener('keydown',event=>{
    if(event.target!==track)return;
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(event.key==='ArrowRight'?1:-1);}
    if(event.key==='Home'||event.key==='End'){event.preventDefault();track.scrollTo({left:event.key==='Home'?0:track.scrollWidth,behavior:reduced()?'instant':'smooth'});}
   },{signal});
   let drag=null;
   track.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('a'))return;
    drag={id:event.pointerId,x:event.clientX,left:track.scrollLeft};
   },{signal});
   track.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    const dx=event.clientX-drag.x;
    if(!this.dragging&&Math.abs(dx)>6){
     this.dragging=true;
     track.classList.add('is-dragging');
     track.setPointerCapture(event.pointerId);
     items.forEach(item=>zoom(item,false));
    }
    if(this.dragging){event.preventDefault();track.scrollLeft=drag.left-dx;}
   },{signal});
   const end=()=>{
    if(!drag)return;
    if(this.dragging){
     this.suppressClickUntil=performance.now()+250;
     this.dragging=false;
     track.classList.remove('is-dragging');
     const target=Math.round(track.scrollLeft/Math.max(1,step()))*step();
     track.scrollTo({left:target,behavior:reduced()?'instant':'smooth'});
    }
    if(track.hasPointerCapture(drag.id))track.releasePointerCapture(drag.id);
    drag=null;
   };
   track.addEventListener('pointerup',end,{signal});
   track.addEventListener('pointercancel',end,{signal});
   track.addEventListener('lostpointercapture',()=>{if(drag)end();},{signal});
   track.addEventListener('pointerleave',()=>{if(!this.dragging)drag=null;},{signal});
   track.addEventListener('dragstart',event=>event.preventDefault(),{signal});
   this.addEventListener('shopify:block:select',event=>{
    const item=event.target.closest('[data-mh-item]');
    if(item)track.scrollTo({left:item.offsetLeft,behavior:'instant'});
   },{signal});
   if('ResizeObserver' in window){this.observer=new ResizeObserver(update);this.observer.observe(track);}
   else window.addEventListener('resize',update,{signal});
   update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.bound=false;}
 });
}


  } catch(e) { console.error(e); }
})();
})();
